import axios from 'axios';

const headers = {
  'Content-Type': 'application/json',
};

const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
if (csrfMetaTag) {
  headers['X-Csrf-Token'] = csrfMetaTag.content;
}

const api = axios.create({ headers });

export default api;
